<template>
	<div class="full" style="box-sizing: border-box;position: relative;">
		<vxe-toolbar>
			<template #buttons>
				<el-button type="primary" size="mini" @click="pull">同步</el-button>
			</template>
		</vxe-toolbar>
		<vxe-table v-if="item" :data="orders" size="mini" max-height="75%" border :perfect="true">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="item_name" title="商品名称"></vxe-column>
			<vxe-column field="payment" title="应收款"></vxe-column>
			<vxe-column field="sku_code" title="规格"></vxe-column>
			<vxe-column field="size" title="数量"></vxe-column>
			<vxe-column field="price" title="单价"></vxe-column>
			<vxe-column field="unit" title="单位"></vxe-column>
			<vxe-column title="操作" width="120" align="center">
				<template #default="{ row }">
					<el-link style="font-size: 12px;" target="_blank" type="primary" :href="row.item_platform_url"
						:disabled="row.item_platform_url==''?true:false">详情页</el-link>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				row: [],
				orders: [],
			}
		},
		watch: {

		},
		computed: {

		},
		created() {
			this.orders = (this.item && this.item.orders) ? this.item.orders : []
		},
		mounted() {

		},
		methods: {
			pull(obj = null) {
				let ordercode = obj.row ? obj.row.ordercode : this.item.ordercode
				return new Promise((reslove) => {
					this.$api.invoiceoutput.listTrades(ordercode, {
						ordercode: ordercode,
						type:'order'
					}).then((res) => {
						let data = res.data
						if (data.length == 0) {
							this.$message.error('暂无订单信息')
						} else {
							let orders = []
							data[0].relation_data.forEach((item) => {
								orders = orders.concat(item.orders)
								if (item.post_fee) {
									orders.push(this.getpostfee(item.post_fee))
								}
								let id = obj.row ? obj.row.id : this.item.id
								this.$api.invoiceoutput.updateorder(id, {
									orders: orders
								}).then(() => {
									this.orders = orders
									reslove()
								}, () => {
									reslove()
								})
							})
						}
					}, () => {
						reslove()
					})
				})
			},
			getpostfee(cost) {
				return {
					bar_code: '100000',
					currency_sum: "0",
					gx_payment: "0",
					gx_price: "0",
					has_refund: "0",
					inventory_status: "已出库",
					is_gift: "0",
					is_package: "",
					item_image_url: "https://img.alicdn.com/bao/uploaded/i3/TB1z1EkQpXXXXaZapXXXXXXXXXX_!!0-item_pic.jpg",
					item_name: "运费（系统自动添加）",
					item_platform_url: "http://item.taobao.com/item.htm?id=554463030991",
					oln_item_id: "100000",
					oln_item_name: "劲功补运费专用/补邮费差价/差几元拍几件/此链接不支持退款！",
					oln_sku_id: "",
					oln_status: "5",
					order_id: "82F1BA15A635322D99E532728D7C6E74",
					order_total_discount: "0",
					payment: cost,
					price: "1",
					receivable: cost,
					remark: "",
					size: cost,
					sku_code: "100000",
					status: "5",
					sys_goods_uid: "506789F0BF703C6A81955D98A6697F01",
					sys_spec_uid: "F17519D4DAAB3EEEB7E50B51E41F82AF",
					tax_payment: "2.58",
					tax_rate: "1",
					tid_snapshot: "TB3521149345928649242",
					tp_oid: "3521149345928649242",
					tp_tid: "3521149345928649242",
				}
			}
		},
		components: {

		}
	}
</script>
